import { apiFetcher } from "./apiFetcher";

export const mobilizeiDevicesService = {
    getPreviewerDeviceStatus,
    sendPreviewerDownloadLink,
    sendTrialPush
};

// Sends the merchant the same link that is behind the QR code, by email. The
// address is the one on his account, so there is nothing to send in the body.
function sendPreviewerDownloadLink(platformId, storeId) {
    const url = `platforms/${platformId}/stores/${storeId}/send_previewer_download_email`

    return apiFetcher(url, { method: "POST" }).then(response => response);
}

function getPreviewerDeviceStatus(platformId, storeId) {
    const url = `platforms/${platformId}/stores/${storeId}/previewer_devices/status`

    return apiFetcher(url, { method: "GET" }, false).then(response => response);
}

function sendTrialPush(platformId, storeId, { title, text, isCustom }) {
    const url = `platforms/${platformId}/stores/${storeId}/previewer_devices/send_trial_push`

    return apiFetcher(url, {
        method: "POST",
        body: JSON.stringify({ title, text, isCustom })
    }).then(response => response);
}
